module.exports = __webpack_public_path__ + "static/media/value-proposition-free.4098fb27.png";